export default () => ({
  component: 'logs-type-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
